import { create } from 'zustand';

import { toPlayerMessage } from '@/shared/api';
import { isFresh, singleFlight } from '@/shared/lib';

import { fetchAchievements } from '../api/achievements.api';

import type { Achievement } from './types';

interface AchievementsState {
  items: Achievement[];
  isLoading: boolean;
  error: string | null;
  loadedAt: number | null;

  load: (options?: { force?: boolean }) => Promise<void>;
  reset: () => void;
}

export const useAchievementsStore = create<AchievementsState>()((set, get) => ({
  items: [],
  isLoading: false,
  error: null,
  loadedAt: null,

  load: singleFlight(async (options?: { force?: boolean }): Promise<void> => {
    if (!options?.force && isFresh(get().loadedAt)) return;

    set({ isLoading: true, error: null });
    try {
      set({ items: await fetchAchievements(), loadedAt: Date.now() });
    } catch (error) {
      set({ error: toPlayerMessage(error) });
    } finally {
      set({ isLoading: false });
    }
  }),

  reset: () => {
    set({ items: [], error: null, loadedAt: null });
  },
}));
